<script>
  import { getContext } from 'svelte'
  import { formatDateAxis, formatMillions } from '../functions.js'
  export let type = 'y'
  export let ticks = { x: null, y: null }
  export let scale = { x: null, y: null }
  export let height, width
  export let color
  export let x
  export let y
  export let text
  export let anchor = 'middle'
  export let offsetX = 0
  export let offsetY = 0
</script>

<text
  class="annotation"
  x={scale.x(x.marker) + +offsetX}
  y={scale.y(y.casesSevenDays) + +offsetY}
  style="fill: {color}; text-anchor: {anchor};">{text}</text
>

<style>
  .annotation {
    font-size: 0.7rem;
    text-transform: uppercase;
    font-weight: 900;
    stroke: #fff;
    stroke-width: 5px;
    paint-order: stroke;
  }
</style>
